import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    description:
      'Parce que chaque changement dans la vie d’une entreprise apporte son lot de nouveautés, nous avons sélectionné pour vous les meilleures offres pour vous permettre de relever ces défis et poursuivre votre aventure entrepreneuriale.',
    title: 'Collections',
  },
  fr: {
    description:
      'Parce que chaque changement dans la vie d’une entreprise apporte son lot de nouveautés, nous avons sélectionné pour vous les meilleures offres pour vous permettre de relever ces défis et poursuivre votre aventure entrepreneuriale.',
    title: 'Collections',
  },
});

export default locales;
